var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSecuredVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    fill: "#EAF3FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5146,
    y: 47.2285,
    width: 9.94286,
    height: 7.77143,
    rx: 1,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6289,
    y: 47.2285,
    width: 9.94286,
    height: 7.77143,
    rx: 1,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15.7429,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4287,
    y: 20.1714,
    width: 27.1429,
    height: 27.1429,
    rx: 3,
    fill: "#C7DFF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.209,
    y: 39.8349,
    width: 19.3294,
    height: 2.17143,
    rx: 1,
    transform: "rotate(-45 27.209 39.8349)",
    fill: "#413D45"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3926,
    y: 25.6,
    width: 19.9596,
    height: 2.17143,
    rx: 1,
    transform: "rotate(45 28.3926 25.6)",
    fill: "#413D45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.4569,
    cy: 33.2,
    r: 4.42857,
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecuredVault);
export default __webpack_public_path__ + "static/media/icon-secured-vault.df3fc922478b138f3ae3cab2b9b7156c.svg";
export { ForwardRef as ReactComponent };